/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
define(["require", "exports", "azure-devops-ui/Ago", "azure-devops-ui/Card", "azure-devops-ui/Core/Observable", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Header", "azure-devops-ui/Page", "azure-devops-ui/Table", "azure-devops-ui/Util", "azure-devops-ui/Utilities/Date", "azure-devops-ui/Utilities/Provider", "react", "../../Resources", "../Common/KubeCardWithTable", "../Common/Tags", "../Constants", "../KubeFactory", "../RunDetails", "../Utils", "./ImageDetails.scss"], function (require, exports, Ago_1, Card_1, Observable_1, String_1, Header_1, Page_1, Table_1, Util_1, Date_Utils, Provider_1, React, Resources, KubeCardWithTable_1, Tags_1, Constants_1, KubeFactory_1, RunDetails_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ImageDetails = /** @class */ (function (_super) {
        __extends(ImageDetails, _super);
        function ImageDetails(props) {
            var _this = _super.call(this, props) || this;
            _this._getCardContent = function () {
                var items = _this._getImageDetailsRowsData(_this.props.imageDetails);
                var rowClassNames = "flex-row details-card-row-size";
                return (React.createElement("div", { className: "flex-column details-card-content body-m" }, items.map(function (item, index) { return (React.createElement("div", { className: index === 0 ? Util_1.css(rowClassNames, "first-row") : rowClassNames, key: index },
                    React.createElement("div", { className: "text-ellipsis secondary-text details-card-info-field-size" }, item.key),
                    ImageDetails._renderValueCell(item))); })));
            };
            KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.ImageDetails);
            return _this;
        }
        ImageDetails.prototype.render = function () {
            return (React.createElement(Page_1.Page, { className: "image-details-content flex flex-grow" },
                this._getMainHeading(),
                React.createElement("div", { className: "pod-details-right-content page-content page-content-top" },
                    this._getImageDetails(),
                    this._getImageLayers())));
        };
        ImageDetails.prototype.componentDidMount = function () {
            KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.ImageDetails);
        };
        ImageDetails.prototype._getMainHeading = function () {
            var imageDetails = this.props.imageDetails;
            this._displayImageName = Utils_1.Utils.extractDisplayImageName(imageDetails.imageName);
            this._labels = this._getImageLabels(imageDetails.layerInfo);
            var runUrl = this._constructPipelineRunUrl(this._labels, imageDetails.runId);
            var pipelineDetails = {
                jobName: imageDetails.jobName,
                pipelineName: imageDetails.pipelineName,
                runName: imageDetails.pipelineVersion,
                runUrl: runUrl
            };
            var imageCreatedOn = imageDetails.createTime ? new Date(imageDetails.createTime) : new Date();
            var agoTime = Date_Utils.ago(imageCreatedOn, 0 /* Compact */);
            var jobName = RunDetails_1.getRunDetailsText(undefined, pipelineDetails, agoTime);
            return (React.createElement(Header_1.CustomHeader, { className: "image-details-header" },
                React.createElement(Header_1.HeaderIcon, { className: "bolt-table-status-icon-large", iconProps: { iconName: "Back", onClick: this.props.onBackButtonClick, className: "image-details-back-button" }, titleSize: 1 /* Large */ }),
                React.createElement(Header_1.HeaderTitleArea, null,
                    React.createElement(Header_1.HeaderTitleRow, null,
                        React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 1 /* Large */ }, this._displayImageName)),
                    React.createElement(Header_1.HeaderDescription, { className: "text-ellipsis" }, jobName))));
        };
        ImageDetails.prototype._getImageDetails = function () {
            var imageDetails = this.props.imageDetails;
            return (React.createElement(Card_1.CustomCard, { className: "image-details-card k8s-card-padding flex-grow bolt-card-no-vertical-padding" },
                React.createElement(Header_1.CustomHeader, null,
                    React.createElement(Header_1.HeaderTitleArea, null,
                        React.createElement(Header_1.HeaderTitleRow, null,
                            React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */ }, Resources.ImageDetailsHeaderText)))),
                React.createElement(Card_1.CardContent, { className: "image-full-details-table", contentPadding: true }, this._getCardContent())));
        };
        ImageDetails.prototype._getImageDetailsRowsData = function (imageDetails) {
            var imageDetailsRows = [];
            var digest = imageDetails.hash || "";
            var imageType = imageDetails.imageType || "";
            var mediaType = imageDetails.mediaType || "";
            var registryName = this._getRegistryName();
            var imageSize = imageDetails.imageSize;
            var labels = this._labels;
            var tags = imageDetails.tags || [];
            digest && imageDetailsRows.push({ key: Resources.DigestText, value: digest });
            imageType && imageDetailsRows.push({ key: Resources.ImageTypeText, value: imageType });
            tags && tags.length > 0 && imageDetailsRows.push({ key: Resources.TagsText, value: tags });
            mediaType && imageDetailsRows.push({ key: Resources.MediaTypeText, value: mediaType });
            registryName && imageDetailsRows.push({ key: Resources.RegistryText, value: registryName });
            imageSize && imageDetailsRows.push({ key: Resources.ImageSizeText, value: imageSize });
            labels && labels.length > 0 && imageDetailsRows.push({ key: Resources.LabelsText, value: labels });
            return imageDetailsRows;
        };
        ImageDetails.prototype._getImageLayers = function () {
            var imageDetails = this.props.imageDetails;
            var layerInfo = this._sortByCreatedDate(imageDetails.layerInfo);
            var tableProps = {
                id: "image-layers-table",
                showHeader: true,
                showLines: true,
                singleClickActivation: false,
                itemProvider: new Provider_1.ArrayItemProvider(layerInfo),
                ariaLabel: Resources.LayersText,
                columns: ImageDetails._getImageLayersColumns(),
            };
            return (React.createElement(Card_1.CustomCard, { className: "image-layers-card k8s-card-padding bolt-table-card flex-grow bolt-card-no-vertical-padding" },
                React.createElement(Header_1.CustomHeader, null,
                    React.createElement(Header_1.HeaderTitleArea, null,
                        React.createElement(Header_1.HeaderTitleRow, null,
                            React.createElement(Header_1.HeaderTitle, { className: "image-layers-card-header text-ellipsis", titleSize: 0 /* Medium */ }, Resources.LayersText)))),
                React.createElement(Card_1.CardContent, { className: "image-layer-details", contentPadding: false },
                    React.createElement(Table_1.Table, __assign({}, tableProps)))));
        };
        ImageDetails.prototype.getTime = function (date) {
            return date != null ? date.getTime() : 0;
        };
        ImageDetails.prototype._sortByCreatedDate = function (layerInfo) {
            var _this = this;
            layerInfo.sort(function (a, b) {
                // Most recent layer to be shown first
                return _this.getTime(b.createdOn) - _this.getTime(a.createdOn);
            });
            return layerInfo;
        };
        ImageDetails._getImageLayersColumns = function () {
            var columns = [];
            var headerColumnClassName = "kube-col-header";
            var columnContentClassName = "list-col-content";
            columns.push({
                id: "image-layer-directive-col",
                name: Resources.CommandText,
                width: -82,
                minWidth: 300,
                headerClassName: headerColumnClassName,
                className: columnContentClassName,
                renderCell: ImageDetails._renderLayersCommandCell
            });
            columns.push({
                id: "image-layer-size-col",
                name: Resources.SizeText,
                width: new Observable_1.ObservableValue(172),
                headerClassName: headerColumnClassName,
                className: columnContentClassName,
                renderCell: ImageDetails._renderLayersSizeCell
            });
            columns.push({
                id: "image-layer-created-col",
                name: Resources.AgeText,
                width: -18,
                minWidth: 150,
                headerClassName: headerColumnClassName,
                className: columnContentClassName,
                renderCell: ImageDetails._renderLayersAgeCell
            });
            return columns;
        };
        ImageDetails._renderLayersCommandCell = function (rowIndex, columnIndex, tableColumn, imageLayer) {
            var directive = imageLayer.directive || "";
            var layerArguments = imageLayer.arguments || "";
            var textToRender = "-";
            if (directive && layerArguments) {
                textToRender = String_1.localeFormat("{0}: {1}", directive, layerArguments);
            }
            var itemToRender = KubeCardWithTable_1.defaultColumnRenderer(textToRender, "body-m");
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
        };
        ImageDetails._renderLayersSizeCell = function (rowIndex, columnIndex, tableColumn, imageLayer) {
            // Currently size data is not present in imageLayer
            var textToRender = imageLayer.size;
            if (!textToRender || textToRender.toUpperCase() === "0B") {
                textToRender = "-";
            }
            var itemToRender = KubeCardWithTable_1.defaultColumnRenderer(textToRender, "body-m");
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
        };
        ImageDetails._renderLayersAgeCell = function (rowIndex, columnIndex, tableColumn, imageLayer) {
            // Currently created data is not present in imageLayer
            var layerCreatedOn = imageLayer.createdOn ? new Date(imageLayer.createdOn) : new Date();
            var itemToRender = React.createElement(Ago_1.Ago, { className: "body-m", date: layerCreatedOn, format: 0 /* Compact */ });
            return KubeCardWithTable_1.renderTableCell(rowIndex, columnIndex, tableColumn, itemToRender);
        };
        ImageDetails.prototype._getRegistryName = function () {
            var imageParts = this._displayImageName.split("/");
            if (imageParts && imageParts.length > 0) {
                return imageParts[0];
            }
            return "";
        };
        ImageDetails.prototype._getImageLabels = function (layerInfo) {
            var labels = [];
            for (var _i = 0, layerInfo_1 = layerInfo; _i < layerInfo_1.length; _i++) {
                var layer = layerInfo_1[_i];
                var directive = layer.directive;
                if (directive.toLowerCase() === "label") {
                    labels.push(layer.arguments);
                }
            }
            return labels;
        };
        ImageDetails.prototype._constructPipelineRunUrl = function (labels, runId) {
            // These strings are the ones that are added as labels during docker build task
            var teamFoundationCollectionUriMatch = "system.teamfoundationcollectionuri=";
            var teamProjectMatch = "system.teamproject=";
            var buildNumberMatch = "build.buildnumber=";
            var releaseWebUrlMatch = "release.releaseweburl=";
            var teamFoundationCollectionUri = "";
            var teamProject = "";
            var buildNumber = "";
            var releaseWebUrl = "";
            for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
                var label = labels_1[_i];
                releaseWebUrl = this._getMatchingUrlString(label, releaseWebUrlMatch);
            }
            // For release pipeline, the releaseWebUrl is added as a tag during docker build
            if (!!releaseWebUrl) {
                return releaseWebUrl;
            }
            // For build pipeline we construct url from bits found by searching each of the labels
            for (var _a = 0, labels_2 = labels; _a < labels_2.length; _a++) {
                var label = labels_2[_a];
                teamFoundationCollectionUri = this._getMatchingUrlString(label, teamFoundationCollectionUriMatch);
                if (!!teamFoundationCollectionUri) {
                    break;
                }
            }
            if (!teamFoundationCollectionUri) {
                return "";
            }
            for (var _b = 0, labels_3 = labels; _b < labels_3.length; _b++) {
                var label = labels_3[_b];
                teamProject = this._getMatchingUrlString(label, teamProjectMatch);
                if (!!teamProject) {
                    break;
                }
            }
            if (!teamProject) {
                return "";
            }
            for (var _c = 0, labels_4 = labels; _c < labels_4.length; _c++) {
                var label = labels_4[_c];
                buildNumber = this._getMatchingUrlString(label, buildNumberMatch);
                if (!!buildNumber) {
                    break;
                }
            }
            if (!buildNumber) {
                return "";
            }
            return String_1.format("{0}{1}/_build?buildId={2}", teamFoundationCollectionUri, teamProject, runId.toString());
        };
        ImageDetails.prototype._getMatchingUrlString = function (label, match) {
            var index = label.indexOf(match);
            if (index >= 0) {
                return label.substring(index + match.length, label.length);
            }
            return "";
        };
        ImageDetails._renderValueCell = function (tableItem) {
            var key = tableItem.key, value = tableItem.value;
            switch (key) {
                case Resources.LabelsText:
                case Resources.TagsText:
                    return (React.createElement("div", { className: "text-ellipsis details-card-value-field-size" },
                        React.createElement(Tags_1.Tags, { items: value, className: "body-s", showOnlyValues: true })));
                default:
                    return KubeCardWithTable_1.defaultColumnRenderer(value, "details-card-value-field-size");
            }
        };
        return ImageDetails;
    }(React.Component));
    exports.ImageDetails = ImageDetails;
});
